/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * @file questionTopicsModalUtils.js
 */

/**
 * Updates the selected section on modal data shaped as { view, questionsBySectionId }.
 */
export function selectQuestionTopicsModalSection(modal, selectedSectionId) {
  if (!modal?.view) {
    return null;
  }

  return {
    ...modal,
    view: {
      ...modal.view,
      selectedSectionId,
      questions: modal.questionsBySectionId?.[selectedSectionId] || []
    }
  };
}

/**
 * Returns the first section id that has questions, else the first section id.
 */
export function getDefaultQuestionTopicsSectionId(sections = []) {
  return ((sections || []).find((section) => section.questionCount > 0) || sections?.[0])?.id || null;
}
